import { Provider } from '@angular/core';
import { RotorApi } from './rotor.api';

export const apiProviders: Provider[] = [RotorApi];
